import React from 'react';
import Modal from '../../../../../Common/Components/Modal';
import { AdminSidebarResetPwdUserProps } from '../../../../../types/AdminSidebarResetPwdUserProps';
import { useAppContext } from '../../../../../utils/AppContext';
import { postRequestAll } from '../../../../../utils/fetch';

import { ReactComponent as WarningIcon } from '../../../../../img/icons/warning.svg';

function AdminSidebarResetPwdUser(props: AdminSidebarResetPwdUserProps): JSX.Element {
  const {
    setOpenModal,
    selectedUsers,
    setLoader } = props;

  const { addNotification } = useAppContext();

  return (
    <Modal
      setModalOpen={() => setOpenModal(0)}
      className="admin-user-modal"
      title="Reset password"
      primaryButtonAction={async () => {
        setOpenModal(0);
        setLoader();
        if (selectedUsers !== undefined) {
          try {
            const requests: { path: string}[] = Array.from(selectedUsers.values()).map(
              (value) => ({
                path: `/organizations/${value.accountid}/users/${value.userid}/request-password-reset`,
              }),
            );
            postRequestAll(requests)
              .then((results) => {
                if (results.resolved === requests.length) {
                  addNotification({ type: 'success', message: 'Change password request has been emailed to the users.' });
                } else {
                  addNotification({ type: 'error', message: 'Your "Reset password" operation has failed.' });
                }
              });
          } catch (e) {
            addNotification({ type: 'error', message: 'Your "Reset password" operation has failed.' });
          }
        }
      }}
      primaryButtonLabel="Apply"
      secondaryButtonAction={() => setOpenModal(0)}
      secondaryButtonLabel="Cancel"
      borderTopColor="yellow"
    >
      <div className="admin-user-modal-content">
        <WarningIcon className="admin-user-modal-content-icon" />
        Are you sure you want to reset passwords for these users?
      </div>
    </Modal>
  );
}

export default AdminSidebarResetPwdUser;
